import { createResponse } from '../response'

const normalizeCountriesResponse = (data) => {
  data.forEach(function (item) {
    item.id = item.iso2
  })
  return createResponse(data)
}

export {
  normalizeCountriesResponse
}



// WEBPACK FOOTER //
// ./src/api/web/normalize.js